/* template */
<template minapp="mpx" xlang="wxml"><mpx-view @tap="goToPage" class="login-drawer-button-container"><div class="button-title"><mpx-image :class="(isExemption && 'exemption')" :src="(iconUrl)" class="button-title-icon"/><div class="button-title-text">{{ buttonTitle }}</div><mpx-image :src="(ruleUrl)" @tap.stop="goToRule" class="button-title-rule" v-if="(isExemption)"/></div><div class="button-description">{{ descriptionText }}</div><div class="recommend" v-if="(!isExemption)">推荐</div><div class="coupon" v-if="(couponDesc)">{{couponDesc}}</div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m109bbf0a"}'>
  .login-drawer-button-container
    display flex
    flex-direction column
    width 163.5px
    height 70px
    justify-content center
    align-items center
    background #fff
    border-radius 16px
    color #fff
    box-sizing border-box
    border 1px solid #CCCCCC
    position relative
    .button-title
      display flex
      height 16px
      line-height 16px
      font-family PingFangSC-Semibold
      font-size 16px
      margin-bottom 6px
      align-items center
      .button-title-icon
        height 16px
        width 14px
        margin-right 5px
        &.exemption
          height 16px
          width 11.5px
          margin-right 6px
      .button-title-text
        color #333
      .button-title-rule
        width 16px
        height 16px
    .button-description
      font-family PingFangSC-Regular
      font-size 10px
      line-height 10px
      color #999
    .recommend
      padding 3px 5px 4px 5px
      border-radius 0 10px 0 10px
      background #338FFF
      font-family PingFang SC
      font-size 10px
      font-weight normal
      line-height 10px
      text-align center
      letter-spacing 0px
      color #FFFFFFx
      position absolute
      top -1px
      right -1px
    .coupon
      margin-top 6px
      box-sizing border-box
      border 0.5px solid #FFBC91
      padding 1.5px
      font-family PingFang SC
      font-size 9px;
      font-weight normal
      line-height 9px
      letter-spacing 0px
      color #FF6400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m109bbf0a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./login-drawer-button.mpx.js?isComponent&outputPath=components%2Flogin-drawer-button109bbf0a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./login-drawer-button.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Flogin-drawer-button109bbf0a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m109bbf0a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/login-drawer-button109bbf0a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
